module.exports = __webpack_public_path__ + "img/KinokoTable64.4df22cbe.jpg";